import React from 'react';

const HowToPlayContentEN: React.FC = () => {
  return (
    <div className="space-y-4 text-gray-700">
      <div className="bg-blue-50 p-4 rounded-2xl">
        <h3 className="font-bold text-blue-800 mb-2">🎯 The Goal</h3>
        <p>Guess who has which number by watching how they act!</p>
      </div>

      <div className="bg-green-50 p-4 rounded-2xl">
        <h3 className="font-bold text-green-800 mb-2">👥 Players</h3>
        <p>You need 4-10 players. One person will be the "guesser" and the others get secret numbers from 1-9.</p>
      </div>

      <div className="bg-orange-50 p-4 rounded-2xl">
        <h3 className="font-bold text-orange-800 mb-2">🎭 How to Play</h3>
        <div className="space-y-2 text-sm">
          <p><strong>1.</strong> The guesser reads a situation out loud</p>
          <p><strong>2.</strong> Everyone else acts out their reaction based on their number</p>
          <p><strong>3.</strong> Number 1 = very calm, Number 9 = totally crazy!</p>
          <p><strong>4.</strong> The guesser watches and tries to figure out who has which number</p>
        </div>
      </div>

      <div className="bg-purple-50 p-4 rounded-2xl">
        <h3 className="font-bold text-purple-800 mb-2">🏆 Winning</h3>
        <p>The guesser gets points for every correct guess. Then someone else becomes the new guesser!</p>
      </div>

      <div className="bg-yellow-50 p-4 rounded-2xl">
        <h3 className="font-bold text-yellow-800 mb-2">💡 Example</h3>
        <p className="text-sm"><strong>Situation:</strong> "You see a spider in your room"</p>
        <p className="text-sm">• Number 1: Stay calm, maybe ignore it</p>
        <p className="text-sm">• Number 9: Scream and run away!</p>
      </div>
    </div>
  );
};

export default HowToPlayContentEN;